import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { TIPS_CONFIGS } from '../../../constants';
import type { TipCardConfig } from '../../../types';

type PartialTipCardConfig = Omit<TipCardConfig, 'url' | 'onClick'>;

export function useVerifyStrengthTips(): PartialTipCardConfig[] {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	return TIPS_CONFIGS.filter((strengthTip) => strengthTip.verifyFunction(petition));
}
